import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import Chip from 'material-ui/Chip';
import { FormProvider, FormSection } from 'components';
import { setValue } from 'redux/modules/customAudiences';
import { changeField } from 'redux/modules/forms';
import * as styles from './CustomAudienceBuilder.scss';
var CABPixelSection = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var websiteTrafficForm = state.forms && state.forms["websiteTrafficForm_".concat(orgId)] ? _objectSpread({}, state.forms["websiteTrafficForm_".concat(orgId)]) : null;
  var validationErrors = websiteTrafficForm && websiteTrafficForm.validationErrors ? websiteTrafficForm.validationErrors : null;
  return {
    facebookPixels: state.customAudiences.facebookPixels && state.customAudiences.facebookPixels[orgId] ? state.customAudiences.facebookPixels[orgId] : [],
    websiteTrafficForm: websiteTrafficForm,
    formName: "websiteTrafficForm_".concat(orgId),
    theme: state.theme,
    organization: state.organization.current,
    customAudienceBuilder: state.customAudiences.builder,
    audienceName: state.customAudiences.audienceName
  };
}, {
  changeField: changeField,
  setValue: setValue
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(CABPixelSection, _Component);

  var _super = _createSuper(CABPixelSection);

  function CABPixelSection() {
    _classCallCheck(this, CABPixelSection);

    return _super.apply(this, arguments);
  }

  _createClass(CABPixelSection, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          formName = _this$props.formName,
          websiteTrafficForm = _this$props.websiteTrafficForm,
          organization = _this$props.organization;
      return /*#__PURE__*/React.createElement(FormProvider, {
        name: "websiteTrafficForm_".concat(organization.id),
        defaultState: {
          criteriaOperator: 'any',
          selectedPixel: this.props.facebookPixels && this.props.facebookPixels.length ? this.props.facebookPixels[0].id : null,
          includeExclude: 1,
          visitorDays: 30,
          visitorDaysError: '',
          inclusions: [],
          exclusions: []
        }
      }, !!websiteTrafficForm && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
        floatingLabelText: "Audience Name",
        name: 'audienceNameField',
        value: this.props.audienceName,
        onChange: function onChange(_ref) {
          var value = _ref.target.value;

          _this.props.changeField(formName, 'visitorDaysError', '');

          _this.props.setValue('audienceName', value);
        },
        errorText: "".concat(this.props.audienceName.length, "/50"),
        errorStyle: {
          color: 'rgb(224, 224, 224);'
        },
        floatingLabelStyle: {
          color: 'rgb(139, 139, 139)'
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#616161',
          marginRight: 80,
          display: 'inline-block',
          marginTop: 25
        }
      }, "Include people who meet"), /*#__PURE__*/React.createElement(SelectField, {
        value: websiteTrafficForm.criteriaOperator,
        style: {
          width: 64,
          position: 'absolute',
          left: 192,
          top: 9
        },
        onChange: function onChange(e, idx, val) {
          _this.props.changeField(formName, 'criteriaOperator', val);
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 'any',
        primaryText: 'Any'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 'all',
        primaryText: 'All'
      })), /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#616161',
          display: 'inline-block',
          marginLeft: 10
        }
      }, "of the following criteria:")), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 100%'
        }
      }, /*#__PURE__*/React.createElement(SelectField, {
        floatingLabelText: "Facebook Pixel",
        value: websiteTrafficForm.selectedPixel,
        onChange: function onChange(e, i, val) {
          _this.props.changeField(formName, 'selectedPixel', val);
        }
      }, this.props.facebookPixels.map(function (_ref2, index) {
        var id = _ref2.id,
            name = _ref2.name;
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: id,
          primaryText: name,
          key: "fbPixelMenuItem_".concat(index)
        });
      }))), !!websiteTrafficForm.selectedPixel && [/*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement(SelectField, {
        style: {
          top: 10,
          width: 135,
          marginRight: 12
        },
        value: websiteTrafficForm.includeExclude,
        onChange: function onChange(e, i, val) {
          _this.props.changeField(formName, 'includeExclude', val);
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 1,
        primaryText: 'Include'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 2,
        primaryText: 'Exclude'
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: 27,
          marginRight: 12
        }
      }, "All website visitors in the past"), /*#__PURE__*/React.createElement(TextField, {
        style: {
          marginTop: 11,
          width: 65
        },
        name: 'visitorDaysField',
        value: websiteTrafficForm.visitorDays,
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;

          _this.props.changeField(formName, 'visitorDays', value);
        },
        onBlur: function onBlur() {
          var visitorDays = websiteTrafficForm.visitorDays;
          var numVal = parseInt(visitorDays, 10);

          if (isNaN(numVal) || "".concat(visitorDays).match(/\D/)) {
            _this.props.changeField(formName, 'visitorDaysError', 'Invalid number of days');
          } else if (numVal > 180) {
            _this.props.changeField(formName, 'visitorDaysError', 'The maximum timespan is 180 days');
          } else if (numVal <= 0) {
            _this.props.changeField(formName, 'visitorDaysError', 'The timespan must be greater than 0');
          } else {
            _this.props.changeField(formName, 'visitorDaysError', '');
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginRight: 12,
          paddingTop: 27
        }
      }, "days"), !!websiteTrafficForm.visitorDaysError && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red',
          fontSize: 12
        }
      }, websiteTrafficForm.visitorDaysError), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-plus",
        style: {
          color: websiteTrafficForm.visitorDaysError ? '#afafaf' : this.props.theme.colors.secondaryColor,
          cursor: websiteTrafficForm.visitorDaysError ? 'default' : 'pointer',
          fontSize: 24,
          left: 15,
          position: 'relative',
          top: 18
        },
        onClick: function onClick() {
          if (websiteTrafficForm.visitorDaysError) {
            return;
          }

          var keyName = websiteTrafficForm.includeExclude === 1 ? 'inclusions' : 'exclusions';

          var a = _toConsumableArray(websiteTrafficForm[keyName]);

          if (a.find(function (_ref4) {
            var id = _ref4.id;
            return "".concat(id) === "".concat(websiteTrafficForm.selectedPixel, "_").concat(websiteTrafficForm.visitorDays);
          })) {
            return _this.props.changeField(formName, 'visitorDaysError', 'This audience has already been added');
          }

          _this.props.changeField(formName, [keyName], [].concat(_toConsumableArray(a), [{
            id: "".concat(websiteTrafficForm.selectedPixel, "_").concat(websiteTrafficForm.visitorDays),
            pixelId: websiteTrafficForm.selectedPixel,
            pixelName: _this.props.facebookPixels.find(function (_ref5) {
              var id = _ref5.id;
              return "".concat(id) === "".concat(websiteTrafficForm.selectedPixel);
            }).name,
            days: parseInt(websiteTrafficForm.visitorDays, 10)
          }]));
        }
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 100%'
        }
      }, websiteTrafficForm.inclusions.length > 0 && /*#__PURE__*/React.createElement(FormSection, {
        title: "Include"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, websiteTrafficForm.inclusions.map(function (_ref6, index) {
        var id = _ref6.id,
            pixelId = _ref6.pixelId,
            pixelName = _ref6.pixelName,
            days = _ref6.days;
        return /*#__PURE__*/React.createElement(Chip, {
          style: {
            marginRight: 6,
            marginBottom: 6
          },
          onRequestDelete: function onRequestDelete() {
            var a = _toConsumableArray(websiteTrafficForm.inclusions);

            var idx = a.findIndex(function (_ref7) {
              var _id = _ref7.id;
              return "".concat(_id) === "".concat(id);
            });

            if (idx > -1) {
              a.splice(idx, 1);
            }

            _this.props.changeField(formName, 'inclusions', _toConsumableArray(a));

            _this.props.changeField(formName, 'visitorDaysError', '');
          },
          key: "inclusionsCA_Chip_".concat(index)
        }, "Visitors of ", pixelName, " within the last ", days, " days");
      })))), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 100%'
        }
      }, websiteTrafficForm.exclusions.length > 0 && /*#__PURE__*/React.createElement(FormSection, {
        title: "Exclude"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, websiteTrafficForm.exclusions.map(function (_ref8, index) {
        var id = _ref8.id,
            pixelId = _ref8.pixelId,
            pixelName = _ref8.pixelName,
            days = _ref8.days;
        return /*#__PURE__*/React.createElement(Chip, {
          style: {
            marginRight: 6,
            marginBottom: 6
          },
          onRequestDelete: function onRequestDelete() {
            var a = _toConsumableArray(websiteTrafficForm.exclusions);

            var idx = a.findIndex(function (_ref9) {
              var _id = _ref9.id;
              return "".concat(_id) === "".concat(id);
            });

            if (idx > -1) {
              a.splice(idx, 1);
            }

            _this.props.changeField(formName, 'exclusions', _toConsumableArray(a));

            _this.props.changeField(formName, 'visitorDaysError', '');
          },
          key: "exclusionsCA_Chip_".concat(index)
        }, "Visitors of ", pixelName, " within the last ", days, " days.");
      })))), websiteTrafficForm.criteriaOperator === 'all' && function () {
        // This is replicating Facebook's behavior. If you have "all" selected and have more than one criteria, they show this message
        var a = [].concat(_toConsumableArray(websiteTrafficForm.inclusions), _toConsumableArray(websiteTrafficForm.exclusions));
        return a.length > 1;
      }() ? /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 100%'
        }
      }, /*#__PURE__*/React.createElement(Paper, {
        zDepth: 2,
        style: {
          borderRadius: 4,
          marginTop: 24
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderRadius: '4px 0 0 4px',
          flex: '0 0 75px',
          flexDirection: 'column',
          backgroundColor: '#d8a041',
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle",
        style: {
          color: 'white',
          fontSize: 20,
          width: '100%',
          textAlign: 'center'
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 12
        }
      }, /*#__PURE__*/React.createElement("h2", {
        style: {
          fontSize: 16,
          color: this.props.theme.colors.gray1
        }
      }, "Audience Size Might Be Too Small"), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: 12,
          color: this.props.theme.colors.gray1,
          lineHeight: '15px'
        }
      }, "The rules you've set up might result in a small audience. Here are ways to broaden your audience:"), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: 12,
          color: this.props.theme.colors.gray1,
          lineHeight: '15px'
        }
      }, "\u2022 Switch from meeting ALL criteria to meeting ANY criteria or reduce the number of criteria that must be met."))))) : null]));
    }
  }]);

  return CABPixelSection;
}(Component)) || _class);
export { CABPixelSection as default };